import { defineComponent, h, useAttrs } from 'vue'
import {
  VExpansionPanel,
  VExpansionPanels,
  VExpansionPanelText,
  VExpansionPanelTitle
} from 'vuetify/components'
import { hasBooleanishAttr } from './legacyInputProps'

function normalizePanelsAttrs(attrs) {
  const normalized = { ...attrs }

  if (hasBooleanishAttr(attrs.accordion) && normalized.multiple == null) {
    normalized.multiple = false
  }

  delete normalized.accordion

  return normalized
}

function createWrapper(
  name,
  Component,
  legacyClass,
  normalize = (attrs) => attrs
) {
  Component.compatConfig = {
    ...(Component.compatConfig || {}),
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  }

  return defineComponent({
    name,
    compatConfig: {
      RENDER_FUNCTION: false,
      COMPONENT_V_MODEL: false,
      INSTANCE_ATTRS_CLASS_STYLE: false
    },
    inheritAttrs: false,

    setup(_, { slots }) {
      const attrs = useAttrs()

      return () =>
        h(
          Component,
          {
            ...normalize(attrs),
            class: [legacyClass, attrs.class]
          },
          slots
        )
    }
  })
}

const VExpansionPanelsCompat = createWrapper(
  'VExpansionPanelsCompat',
  VExpansionPanels,
  undefined,
  normalizePanelsAttrs
)

const VExpansionPanelCompat = createWrapper(
  'VExpansionPanelCompat',
  VExpansionPanel,
  'v-expansion-panel'
)

const VExpansionPanelHeaderCompat = createWrapper(
  'VExpansionPanelHeaderCompat',
  VExpansionPanelTitle,
  'v-expansion-panel-header'
)

const VExpansionPanelContentCompat = createWrapper(
  'VExpansionPanelContentCompat',
  VExpansionPanelText,
  'v-expansion-panel-content'
)

export {
  VExpansionPanelCompat,
  VExpansionPanelContentCompat,
  VExpansionPanelHeaderCompat,
  VExpansionPanelsCompat
}
